import { useParams } from 'react-router-dom'

import { Box, NotFound } from '@factorialco/deprecated-design-system'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { GroupHeader } from 'modules/expenses/components/groups/GroupHeader'
import { useGroupDetail } from 'modules/expenses/hooks/useGroupDetail'
import { useMyExpenses } from 'modules/expenses/pages/my_expenses/MyExpensesContext'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import policyPeriods from 'modules/payroll_bundle/store/collections/policyPeriods'

import ExpensesList from './List'
import { usePageActions } from './usePageActions'

const MyGroupDetailPage = () => {
  const { groupId } = useParams()
  const { navigation } = useNavigation()
  const { featureAvailabilities } = useMyExpenses()

  const { value: currentPayrollPeriod } = useAsyncData(() => policyPeriods.isCurrentOpen(), [])

  const { group, loading: loadingGroup } = useGroupDetail({ id: Number(groupId) })
  const { actions, Modals } = usePageActions({
    group,
    currentPayrollPeriodOpen: Boolean(currentPayrollPeriod?.open_to_supplements),
    reimburseThroughPayrollEnabled: featureAvailabilities.reimburseThroughPayroll,
  })

  return (
    <>
      {group && <GroupHeader group={group} actions={actions} />}
      <ResponsivePage.Body showHeader={false} error={false} loading={loadingGroup} variant="full">
        <Modals />
        {group ? (
          <Box gap="s16">
            <ExpensesList
              group={group}
              back={{ href: navigation.myExpenses.groups.id.fullPath({ groupId: group.id }) }}
            />
          </Box>
        ) : (
          <NotFound
            title={i18n.t('errors.page_not_found.title')}
            description={i18n.t('errors.page_not_found.description')}
          />
        )}
      </ResponsivePage.Body>
    </>
  )
}

export default MyGroupDetailPage
